import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useEquipmentTypes } from '../../hooks';
import type { EquipmentType, EquipmentTypeFilters } from '../../models';

export interface EquipmentTypeFieldProps extends Omit<SelectProps<EquipmentType>, 'options'> {
  defaultFilters?: Partial<EquipmentTypeFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<EquipmentType>['errorMessage'];
  isInvalid?: boolean;
}

export const EquipmentTypeField: React.FC<EquipmentTypeFieldProps> = ({
  defaultFilters,
  label,
  ...otherFieldProps
}) => {
  const { data, isLoading, updateFilters } = useEquipmentTypes(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { description: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { description: search } })}
      isLoading={isLoading}
    />
  );
};
